export default __webpack_public_path__ + "static/media/4a13b5995e44a435098520d026f17ddf1576756146374.c2d712d6.webp";